// Provides default filter values shared by Table and FilterBox
// Needs to be function to re-create values each time, Vue makes obj reactive otherwise
export const getDefaultFilterData = () => {
    return {
        filterByClient: null,
        filterByCourse: null,
        filterByUsergroup: null,
        status: [
            'overdue',
            'pending',
            'processing',
            'completed',
            'not_assigned',
        ],
        filterByActive: 'all',
    };
};
